/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createJobResponse } from '../models/api_createJobResponse';
import type { api_getBudgetExportDetailsResponse } from '../models/api_getBudgetExportDetailsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Budgets {
    /**
     * Import plagiarism scan results
     * @param programmeCode Programme code
     * @param file CSV file to be imported
     * @returns api_createJobResponse OK
     * @throws ApiError
     */
    public static importBudget(
        programmeCode: string,
        file: Blob,
    ): CancelablePromise<api_createJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/budgets/{programme_code}',
            path: {
                'programme_code': programmeCode,
            },
            formData: {
                'file': file,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get budget export details
     * @param programmeCode Programme code
     * @param awardIds Award IDs
     * @returns api_getBudgetExportDetailsResponse OK
     * @throws ApiError
     */
    public static getBudgetExportDetails(
        programmeCode: string,
        awardIds?: string,
    ): CancelablePromise<api_getBudgetExportDetailsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/budgets/{programme_code}/details',
            path: {
                'programme_code': programmeCode,
            },
            query: {
                'award_ids': awardIds,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Export budget
     * @param programmeCode Programme code
     * @param exportType Export type
     * @param awardIds Award IDs
     * @returns api_createJobResponse OK
     * @throws ApiError
     */
    public static exportBudget(
        programmeCode: string,
        exportType: string,
        awardIds?: string,
    ): CancelablePromise<api_createJobResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/budgets/{programme_code}/{export_type}',
            path: {
                'programme_code': programmeCode,
                'export_type': exportType,
            },
            query: {
                'award_ids': awardIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                502: `Bad Gateway`,
            },
        });
    }
}
